import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";
import { keyPressTH, removeNonEnglishChars } from "src/app/functions/string-formatter.function";

@Directive({
  selector: '[englishInput]'
})
export class EnglishInputDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const isValid = keyPressTH(event);
    if (!isValid) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur() {
    const control = this.ngControl.control;
    if (!control || !control.value) return;

    const newValue = removeNonEnglishChars(control.value);
    control.setValue(newValue, { emitEvent: false });
  }
}